import { Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { localise } from '../../../../services/lang/lang';
import OfficerAssessmentActionMenu from './ActionMenu/OfficerAssessmentActionMenu';
const OfficerAssessmentPanelHeader = ({ officerAssessment, remoteSubmission, }) => (React.createElement(Flex, { "data-testid": "officer_assessment_panel_header", display: "flex", align: "center", justifyContent: "space-between" },
    React.createElement(Text, { "data-testid": "officer_assessment_panel_header__title", as: "h3", variant: "dk-800-rg-3" }, localise('OFFICER_ASSESSMENT')),
    React.createElement(OfficerAssessmentActionMenu, { officerAssessment: officerAssessment, remoteSubmission: remoteSubmission })));
export default OfficerAssessmentPanelHeader;
